/** basic.temporarilyUser */
export default {
    tem_receiveSms: "Получение SMS",
    tem_receivePhone: "Получение звонков",
    tem_name: "Имя временного пользователя",
    tem_UserPhone: "Телефон временного пользователя",
    tem_delectTips: "Удалить этого временного пользователя?",
    tem_drawerTitle: "Детали временного пользователя",
    tem_dialogTitle: "Новый временный пользователь",
    tem_rulerNoSpecialStr: "Нельзя использовать специальные символы!",
    tem_rulerPhoneMax: "Телефон должен быть из 11 цифр",
    tem_receive: "Получать",
    tem_noReceive: "Не получать",
    tem_phone: "Телефон",
    tem_isReceiveSms: "Получать SMS",
    tem_isReceivePhone: "Получать звонки",
    tem_creater: "Создать",

    rule_length: "Длина 11 символов",
    rule_UserNameNoSpecial: "Имя временного пользователя не может быть пустым",
    rule_phoneNoSpecial: "Телефон не может быть пустым",
    rule_receiveSms: "Выберите, получать ли SMS",
    rule_receivePhone: "Выберите, получать ли звонки",
    rule_createrUserID: "ID создателя",

    message_addSucc: "Временный пользователь добавлен!",
    message_addLose: "Не удалось добавить временного пользователя!",
}

